import { TranslateResult } from 'vue-i18n';

import { i18n } from '@dh-io-otb/shared/src/services/translation.service';

export const useProspect = () => {
  const buildProspectAddress = (address): TranslateResult => {
    return i18n.t('summary.address.template', address);
  };

  const buildProspectName = (customer): TranslateResult => {
    const translatedSet = Object.assign({}, customer);
    ['title', 'salutation'].forEach((key) => {
      translatedSet[key] = i18n.t(
        `contact.form.customer.${key}.${
          customer ? customer[key]?.toLowerCase() : ''
        }`
      );
    });
    return i18n.t('summary.name.template', translatedSet);
  };

  const buildProspectTitle = (customer): string => {
    const titlePrefix = i18n.t('summary.name.prefix');
    const name = buildProspectName(customer);
    return `${titlePrefix} ${name}.`;
  };

  return {
    buildProspectAddress,
    buildProspectName,
    buildProspectTitle,
  };
};
